import LiView from "./src/index.vue";

LiView.install = function (Vue) {
  Vue.component(LiView.name, LiView);
};

export default LiView;
